export function pluralize(singular, num, plural) {
    if (num > 1) {
        return plural || singular + 's';
    }
    return singular;
}

export function formatPrice(price) {
    return parseFloat(price).toFixed(2).replace('.', ',');
}

export function readFileAsDataURL(file) {
    console.log('readFileAsDataURL received file', file);

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', eventLoad => {
            console.log('readFileAsDataURL event load', eventLoad);
            resolve(eventLoad.target.result);
        });
        reader.addEventListener('error', eventError => {
            console.log('readFileAsDataURL event error', eventError);
            reject(eventError);
        });
        reader.readAsDataURL(file);
    });
}

// See https://developer.mozilla.org/fr/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
export function storageAvailable(type) {
    try {
        var storage = window[type],
            x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return (
            e instanceof DOMException &&
            // everything except Firefox
            (e.code === 22 ||
                // Firefox
                e.code === 1014 ||
                // test name field too, because code might not be present
                // everything except Firefox
                e.name === "QuotaExceededError" ||
                // Firefox
                e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage.length !== 0
        );
    }
}
